// const server = "http://localhost";
// const server2 = "http://localhost";
// const domain = "localhost";
// const port = 9555;
// const port2 = 9556;
const serverImg = 'https://cdnmilo.mansolutions.app';
const server = "https://apimilo.mansolutions.app";
const server2 = "https://apigrupo.mansolutions.app";
const port = 443;
const port2 = 443;
const domain = "milo.mansolutions.app";
export { server, server2, port, port2, domain, serverImg };
